import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Address = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const noBranchInvolved = useWatch({ control, name: `institutionActivitiesInfo.${index1 as 0}.noBranchInvolved` })

  return (
    <Controller
      name={
        // eslint-disable-next-line max-len
        `institutionActivitiesInfo.${index1 as 0}.institutionActivityBranchesInfo.${index2 as 0}.address`
      }
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="69. Address of branch or office where activity occurred"
          input={(props) => <TextInput {...props} disabled={noBranchInvolved} />}
        />
      )}
    />
  )
}
